import { extendedCatalogCardSx } from '@/components/blocks/ProductDetails/styles/inventoryAvailability';
import { useLocalization } from '@/data/Localization';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

/** Card shown for Extended Catalog products; replaces the physical store availability card entirely (US-160135). */
export const ExtendedCatalogCard: FC = () => {
	const { Availability } = useLocalization('HDMProductDetail');

	return (
		<Paper
			sx={extendedCatalogCardSx.card}
			elevation={1}
			id="extendedCatalogCard"
			className="extended-catalog-card"
		>
			<Stack spacing={1.25} alignItems="flex-start">
				<Box sx={extendedCatalogCardSx.badge} className="extended-catalog-card__badge">
					<Typography variant="bodySubText" component="span" sx={extendedCatalogCardSx.badgeText}>
						{Availability.labels.catalogExtendedBadge.t()}
					</Typography>
				</Box>
				<Typography
					variant="bodyBaseline"
					component="p"
					sx={extendedCatalogCardSx.description}
					className="extended-catalog-card__description"
				>
					{Availability.labels.catalogExtendedDescriptionPrefix.t()}
					<Typography
						variant="bodyBaseline"
						component="span"
						fontWeight={OpenSansFontWeights.semibold}
						sx={extendedCatalogCardSx.description}
					>
						{Availability.labels.catalogExtendedDescriptionHighlight.t()}
					</Typography>
					{Availability.labels.catalogExtendedDescriptionSuffix.t()}
				</Typography>
			</Stack>
		</Paper>
	);
};
